<po-page-list
  p-title="Relatório - Transferências Expedição"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row">
      <po-button class="po-md-2 po-mb-2" p-kind="secondary" p-label="Excel" (p-click)="gerarExcel()" > </po-button>
  </div>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-hide-columns-manager="true"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>
</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DB8DATA_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DB8DATA_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de:"
    ></po-datepicker>

    <po-datepicker
      class="po-md-6"
      name="DB8DATA_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DB8DATA_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até:"
    ></po-datepicker>

    <po-input
      class="po-md-6"
      name="CB8LOTECTL"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CB8LOTECTL"
      p-label="Lote"
      [p-maxlength]="8"
    ></po-input>

    <po-lookup
      class="po-md-6"
      name="CB8PRODUTO"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CB8PRODUTO"
      p-field-label="CB1DESC"
      p-field-value="CB1COD"
      p-label="Produto"
      [p-columns]="columnsProdutoFilters"
      [p-field-format]="fieldFormaterProdutoFilters"
      [p-filter-service]="produtoLookupService"
      [p-advanced-filters]="advancedProdutoFilters"
      [p-literals]="{ modalTitle: 'Produto' }"
      [p-filter-params]="{CB1MSBLQL: '2'}"
    ></po-lookup>

    <po-select class="po-md-6"
      name="CB8LOCAL"
      p-label="Armazém"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CB8LOCAL"
      [p-options]="[
      {value: '', label: 'Ambos'},
      {value: 'OT', label: 'OT'},
      {value: 'OR', label: 'OR'},
      ]"
    ></po-select>
  </form>
</po-modal>
